import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';

import { FertilizerProductsState, FertilizerProductsActions } from './types';
import {
    FERTILIZER_PRODUCTS_SET,
    FERTILIZER_PRODUCT_DELETE_SUCCEEDED,
    FERTILIZER_PRODUCT_SET
} from './constants';

const initialState: FertilizerProductsState = {};

export default function (
    state: FertilizerProductsState = initialState,
    action: FertilizerProductsActions
): FertilizerProductsState {
    switch (action.type) {
        case FERTILIZER_PRODUCTS_SET:
            return get(action, 'payload', {});
        case FERTILIZER_PRODUCT_SET:
            return {
                ...state,
                ...get(action, 'payload', {})
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
